export const PHONE = '(727) 283-6452';
export const PHONE_HREF = 'tel:17272836452';
export const EMAIL = 'info@sightlinenetworks.com';
export const MAIN_SITE_URL = 'https://sightlinenetworks.com';
export const HOSTING_URL = 'https://host.sightlinenetworks.com';

export const PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    monthlyPrice: 20,
    annualPrice: 200,
    annualMonthly: 17,
    description: 'Perfect for small business websites, landing pages, and brochure sites.',
    features: [
      '1 website',
      '15 GB SSD storage',
      '2 GB RAM / 2 vCPU',
      'Unlimited bandwidth',
      'Free SSL certificate',
      'Daily automated backups',
      '10 email accounts',
      'LiteSpeed web server',
      'Free domain (1st year)',
      'cPanel access',
      '99.9% uptime SLA',
      'Email support',
    ],
    featured: false,
  },
  {
    id: 'plus',
    name: 'Plus',
    monthlyPrice: 29.99,
    annualPrice: 299,
    annualMonthly: 24.92,
    description: 'Ideal for growing businesses that need more power and priority support.',
    features: [
      'Up to 2 websites',
      '30 GB SSD storage',
      '3 GB RAM / 2 vCPU',
      'Unlimited bandwidth',
      'Free SSL certificate',
      'Daily automated backups',
      '20 email accounts',
      'LiteSpeed web server',
      'Free domain (1st year)',
      'cPanel access',
      'Staging environment',
      '99.9% uptime SLA',
      'Priority phone & email support',
    ],
    featured: true,
  },
  {
    id: 'pro',
    name: 'Pro',
    monthlyPrice: 36.99,
    annualPrice: 369,
    annualMonthly: 30.75,
    description: 'For high-traffic sites and businesses that need maximum performance.',
    features: [
      'Up to 10 websites',
      '50 GB SSD storage',
      '6 GB RAM / 4 vCPU',
      'Unlimited bandwidth',
      'Free SSL certificate',
      'Daily automated backups',
      '50 email accounts',
      'LiteSpeed web server',
      'Free domain (1st year)',
      'cPanel access',
      'Staging environment',
      'Disaster recovery',
      '99.99% uptime SLA',
      'Dedicated support manager',
    ],
    featured: false,
  },
];

export const COMPARISON_FEATURES = [
  { name: 'Websites', starter: '1', plus: '2', pro: '10' },
  { name: 'SSD Storage', starter: '15 GB', plus: '30 GB', pro: '50 GB' },
  { name: 'RAM / vCPU', starter: '2 GB / 2', plus: '3 GB / 2', pro: '6 GB / 4' },
  { name: 'Bandwidth', starter: 'Unlimited', plus: 'Unlimited', pro: 'Unlimited' },
  { name: 'Email Accounts', starter: '10', plus: '20', pro: '50' },
  { name: 'Free SSL', starter: true, plus: true, pro: true },
  { name: 'Daily Backups', starter: true, plus: true, pro: true },
  { name: 'LiteSpeed Server', starter: true, plus: true, pro: true },
  { name: 'cPanel Access', starter: true, plus: true, pro: true },
  { name: 'Free Domain (1yr)', starter: true, plus: true, pro: true },
  { name: 'Staging Environment', starter: false, plus: true, pro: true },
  { name: 'Disaster Recovery', starter: false, plus: false, pro: true },
  { name: 'Uptime SLA', starter: '99.9%', plus: '99.9%', pro: '99.99%' },
  { name: 'Support', starter: 'Email', plus: 'Priority phone & email', pro: 'Dedicated manager' },
];
